import { createElementBlock as o, openBlock as t, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
};
function l(c, e) {
  return t(), o("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M16 2.667C8.636 2.667 2.667 8.636 2.667 16c0 6.684 4.924 12.204 11.34 13.168v-9.635h-3.299v-3.505h3.299v-2.332c0-3.861 1.881-5.556 5.09-5.556 1.538 0 2.35.113 2.735.165v3.059h-2.19c-1.362 0-1.838 1.292-1.838 2.748v1.916h3.993l-.541 3.505h-3.45v9.663c6.507-.881 11.527-6.447 11.527-13.196 0-7.364-5.969-13.333-13.333-13.333"
    }, null, -1)
  ])]);
}
const h = { render: l };
export {
  h as default,
  l as render
};
